import { BaseLayoutFactory } from '../global/base-layout-factory';
import { PncpPurchaseContractDetailProvider } from './context/pncp-purchase-contract-detail-context';
import { PncpPurchaseContractDetailComponent } from './pncp-purchase-contract-detail-component';

export function PncpPurchaseContractDetailFactory() {
    return (
        <BaseLayoutFactory>
            <PncpPurchaseContractDetailProvider>
                <PncpPurchaseContractDetailComponent />
            </PncpPurchaseContractDetailProvider>
        </BaseLayoutFactory>
    );
}
